import { TagLogEntry } from 'lib-shared-legacy-types';

import { getLogEntryAuthorName, LogEntry } from './logEntry';
import { UserLink } from './userLink/userLink';

type ConversationTaggedProps = {
  entry: TagLogEntry;
};

export const ConversationTagged = ({
  entry,
}: ConversationTaggedProps): JSX.Element => {
  const actionType =
    entry.activity_type === 'TAG_ADDED' ? 'tagged' : 'untagged';

  const authorName = getLogEntryAuthorName(entry);
  const authorLink = <UserLink userId={entry.author.id}>{authorName}</UserLink>;

  const text = (
    <>
      Conversation is {actionType} with "{entry.tag_name}" by {authorLink}
    </>
  );

  return <LogEntry entry={entry} text={text} />;
};
